import { render, staticRenderFns } from "./Simulador.vue?vue&type=template&id=d1702bfe"
import script from "./Simulador.vue?vue&type=script&lang=js"
export * from "./Simulador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports